import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { StatCard } from './stat-card'
import { UserSessionType } from '../../types'
import { numberWithCommas } from '../../utils'
import StatOneIcon from '../../assets/images/bf3bf099-8cfe-44b2-bf0f-146536d85bd7.png'
import StatTwoIcon from '../../assets/images/bcea5921-dc8b-493b-9662-026b5ffd2fb7.png'
import StatThreeIcon from '../../assets/images/c32730da-1fd5-4d67-874f-5464191afd24.png'

export const TopStats = ({
  userSession,
  customerCompanyId,
  queriesOfRestrictive,
  noveltiesSolvedQuantity,
  paymentsWithBackgroundResearchQuantity
}: {
  customerCompanyId: string
  userSession: UserSessionType
  queriesOfRestrictive: number
  noveltiesSolvedQuantity: number
  paymentsWithBackgroundResearchQuantity: number
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation(['insights-funding-history-management'])

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mt-6 custom-grid-cols-1">
      <StatCard
        customIcon={
          <div className="relative">
            <div className="flex items-center justify-center bg-white rounded-full w-10 h-10 md:w-12 md:h-12">
              <img
                src={StatOneIcon}
                alt="Currency logo"
                className="w-5 h-5 md:w-6 md:h-6"
              />
            </div>
            <div className="absolute bottom-0 right-0 translate-x-1/4 translate-y-1/4 bg-[#F59E0B] rounded-full w-3 h-3 md:w-4 md:h-4 flex items-center justify-center">
              <span className="text-white font-bold text-[0.6rem] md:text-xs">!</span>
            </div>
          </div>
        }
        number={numberWithCommas(paymentsWithBackgroundResearchQuantity)}
        title={t('insights.topStats.paymentWithAlerts')}
        variant="highlight"
        action={{
          label: 'Ver pagos',
          onClick: () => {
            if (userSession && userSession.role === 'super-admin') {
              navigate(`/payments-with-alerts/${customerCompanyId}`, { state: { previousPath: 'insights' } })
            }

            if (userSession && userSession.role.indexOf('-client') > -1) {
              navigate(`/payments-to-review`, { state: { previousPath: 'insights' } })
            }
          }
        }}
        onIconClick={() => {
          if (userSession && userSession.role === 'super-admin') {
            navigate(`/payments-with-alerts/${customerCompanyId}`, { state: { previousPath: 'insights' } })
          }

          if (userSession && userSession.role.indexOf('-client') > -1) {
            navigate('/payments-to-review', { state: { previousPath: 'insights' } })
          }
        }}
        height="tall"
      />
      <StatCard
        customIcon={
          <div className="relative">
            <div className="flex items-center justify-center bg-[rgba(239,250,249,1)] rounded-full w-10 h-10 md:w-12 md:h-12">
              <img
                src={StatTwoIcon}
                alt="Document logo"
                className="w-5 h-5 md:w-6 md:h-6"
              />
            </div>
          </div>
        }
        number={numberWithCommas(queriesOfRestrictive)}
        title={t('insights.topStats.queriesOnRestrictiveLists')}
        description={t('insights.topStats.queriesOnRestrictiveListsText')}
        onIconClick={() => console.log('Consultas en listas restrictivas')}
        height="tall"
      />
      <StatCard
        customIcon={
          <div className="relative">
            <div className="flex items-center justify-center bg-[rgba(239,250,249,1)] rounded-full w-10 h-10 md:w-12 md:h-12">
              <img
                src={StatThreeIcon}
                alt="User logo"
                className="w-5 h-5 md:w-6 md:h-6"
              />
            </div>
          </div>
        }
        number={numberWithCommas(noveltiesSolvedQuantity)}
        title={t('insights.topStats.beneficiariesAlertsSolved')}
        description={t('insights.topStats.beneficiariesAlertsSolvedText')}
        onIconClick={() => console.log('Novedades de beneficiarios solucionadas')}
        height="tall"
      />
    </div>
  )
}
